import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export default function VerticalCard({ vertical }) {
  const Icon = vertical.icon;
  return (
    <Link
      to={`/verticals/${vertical.slug}`}
      data-testid="vertical-card"
      className="group relative rounded-2xl bg-gradient-to-b from-white/[0.05] to-white/[0.02] border border-white/10 p-6 backdrop-blur-xl lift-on-hover hover:border-white/25 hover:shadow-[0_22px_60px_rgba(124,58,237,0.10)] overflow-hidden"
    >
      <div
        className="absolute -bottom-16 -left-16 h-40 w-40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
        style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.18), transparent 65%)' }}
        aria-hidden
      />
      <div className="flex items-center gap-3">
        <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#0B172A] border border-white/10">
          <Icon className="h-5 w-5 text-[#A78BFA]" />
        </span>
        <div>
          <span className="text-[10.5px] uppercase tracking-[0.18em] text-slate-500">Vertical</span>
          <h3 className="font-display text-[18px] font-semibold tracking-[-0.02em] text-white -mt-0.5">{vertical.title}</h3>
        </div>
        <ArrowUpRight className="ml-auto h-4 w-4 text-slate-500 group-hover:text-[#22D3EE] transition-colors" />
      </div>
      <p className="mt-3 text-[14px] text-slate-300/85 leading-relaxed line-clamp-3">{vertical.intro}</p>
      <div className="mt-4">
        <div className="text-[10.5px] uppercase tracking-[0.18em] text-slate-500">Best formats</div>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {vertical.formats.slice(0, 4).map((f) => (
            <span key={f} className="px-2 py-0.5 rounded-full bg-white/[0.04] border border-white/10 text-[11px] text-slate-300 font-medium">{f}</span>
          ))}
        </div>
      </div>
      <div className="mt-5 pt-4 border-t border-white/10 inline-flex items-center gap-1 text-[12px] font-semibold text-[#22D3EE]">
        Explore vertical <ArrowUpRight className="h-3.5 w-3.5" />
      </div>
    </Link>
  );
}
